module.exports = __webpack_public_path__ + "fonts/PingFangSC.212ada59.ttf";